import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { CroppedImage } from './CroppedImage';
import { PURCHASE_MOCKUP, OFFER_TITLE, bonus, offerExtras, offerVolumes, pricing } from '../data/resinContent';
export function OfferSection() {
  return <section id="offer" className="w-full border-y border-champagne/25 bg-black py-12 sm:py-16" aria-labelledby="offer-title" data-id="element-215" data-mp="idrmbl71uixa">
      <div className="mx-auto max-w-4xl px-5" data-id="element-216" data-mp="mdiffvk1tb4z">
        {/* Launch price */}
        <div className="border border-champagne/30 bg-charcoal-950 px-5 py-7 text-center sm:px-8" aria-labelledby="launch-title" data-id="element-217" data-mp="rdn0zzztcw22">
          <h2 id="launch-title" className="text-[11px] font-semibold uppercase tracking-[0.3em] text-champagne" data-id="element-218" data-mp="wchi8xi4uck2">
            Launch price
          </h2>
          <p className="mt-3 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-219" data-mp="2y3uj9bgzc0au">
            <span className="mr-2 align-middle font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-ivory-300" data-id="element-220" data-mp="12o1r8qy1mg28">
              Today
            </span>
            {pricing.today}
            <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-221" data-mp="sx78vxnx40m2">
              USD
            </span>
          </p>
          <p className="mt-2 text-[12px] uppercase tracking-[0.12em] text-muted" data-id="element-222" data-mp="ouakfqbp5aa7">
            Regular price <span className="line-through" data-id="element-223" data-mp="1lk0aei94t3x4">{pricing.regularPrice}</span>
          </p>
          <CountdownTimer label="Launch offer ends in" size="lg" className="mt-6" data-id="element-224" data-mp="1gl6wwptuhcwy" />
          <p className="mt-5 text-[11px] font-medium uppercase tracking-[0.14em] text-rose" data-id="element-225" data-mp="1ck4wi5o6yute">
            Price increases when the launch offer ends.
          </p>
        </div>

        {/* Complete offer */}
        <h2 id="offer-title" className="mt-12 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-226" data-mp="17ud2pvc8b1m">
          {OFFER_TITLE}
        </h2>

        <div className="mt-8 grid items-start gap-8 sm:grid-cols-2 sm:gap-10" data-id="element-227" data-mp="3ts6gef8kn49c">
          <CroppedImage image={PURCHASE_MOCKUP} className="mx-auto w-full max-w-sm sm:sticky sm:top-8 sm:max-w-none" data-id="element-228" data-mp="2llxxjwl14nx" />

          <div data-id="element-229" data-mp="3ouwlik2ey0e4">
            <ul className="space-y-2" data-id="element-230" data-mp="3oumxv34uc5bl">
              {offerVolumes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-231" data-mp="3b3i3afgby384">
                  <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-232" data-mp="3b26zifmvwvh0" />
                  <span className="text-[14px] font-medium leading-snug text-ivory-50" data-id="element-233" data-mp="3fw1ifguo16f1">{item}</span>
                </li>)}
            </ul>

            <p className="mt-5 flex items-start gap-2.5 border-y border-champagne/25 py-3.5" data-id="element-234" data-mp="3656t23m4hqpd">
              <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-235" data-mp="2s5ozzc1snra7" />
              <span className="text-[14px] leading-snug text-ivory-50" data-id="element-236" data-mp="2x37av7zdggku">
                <span className="mr-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-champagne" data-id="element-237" data-mp="2dh5hi1ftzw2d">Plus</span>
                {bonus.title}
              </span>
            </p>

            <ul className="mt-5 grid grid-cols-2 gap-x-3 gap-y-2" data-id="element-238" data-mp="2mj4y4smxoy4s">
              {offerExtras.map(item => <li key={item} className="flex items-start gap-2" data-id="element-239" data-mp="2igs0ysm968jm">
                  <CheckIcon className="mt-1 h-3 w-3 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-240" data-mp="2wgt1u82ipfz3" />
                  <span className="text-[13px] leading-snug text-ivory-200" data-id="element-241" data-mp="2ri854imh5efe">{item}</span>
                </li>)}
            </ul>

            <p className="mt-6 text-[10px] font-semibold uppercase tracking-[0.2em] text-champagne" data-id="element-242" data-mp="3662z02c7xou2">Ideal for</p>
            <p className="mt-1 text-[12px] font-medium uppercase leading-relaxed tracking-[0.08em] text-ivory-300" data-id="element-243" data-mp="319ma35x736fx">
              {pricing.idealFor}
            </p>

            <p className="mt-6 border-t border-charcoal-600 pt-5 text-[12px] uppercase tracking-[0.12em] text-muted" data-id="element-244" data-mp="3a993b4frt5xw">
              Regular price <span className="line-through" data-id="element-245" data-mp="18gxrzo6p0ce2">{pricing.regularPrice}</span>
            </p>
            <p className="mt-1 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-246" data-mp="1dgado5ltvdf2">
              <span className="mr-2 align-middle font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-champagne" data-id="element-247" data-mp="1iay3c7skidv8">
                Today
              </span>
              {pricing.today}
              <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-248" data-mp="pm91u7nlo6iy">
                USD
              </span>
            </p>

            <div className="mt-6" data-id="element-249" data-mp="yjazfywh0mbm">
              <CtaButton target="checkout" size="md" label="Get access now →" data-id="element-250" data-mp="13jxjl6mdexjs" />
            </div>
            <TrustStrip className="mt-3 sm:justify-start" data-id="element-251" data-mp="2a0195s03rw9z" />
          </div>
        </div>
      </div>
    </section>;
}